// extracted by mini-css-extract-plugin
module.exports = {"supplier_manager":"supplier_supplier_manager__p3E35","card":"supplier_card__1BZYL"};